import { useEffect, useRef, useState } from 'react';

export function useSelectActiveTab(index) {
  const flickityRef = useRef();
  const [flickityRefIsMounted, setFlickityRefIsMounted] = useState(false);

  const flickityRefSetter = (flickityInstance) => {
    flickityRef.current = flickityInstance;
    setFlickityRefIsMounted(true);
  };

  useEffect(() => {
    // double checking for hot-reloading which doesn't update the value of isMounted
    if (flickityRefIsMounted && flickityRef.current) {
      // handle select on useEffect instead of onClick in order to update on mount
      flickityRef.current.select(index);
    }
  }, [flickityRefIsMounted, index]);

  return { flickityRefSetter };
}
